import _ from 'lodash';
import { toNumber } from './toNumber';

export const round = (number, decimals = 2) => toNumber(_.round(toNumber(number), decimals));
